/**
 * Does nothing (no operation).
 *
 * @param {any[]} args The arguments to ignore.
 *
 * @returns {void}
 */
export const noop = ( ...args ) => {}; // eslint-disable-line no-unused-vars
